import { makeStyles, Theme } from "@material-ui/core/styles"
import theme from "../../theme"

// 侧边栏抽屉组件
export const useSideDrawerStyles = makeStyles((theme: Theme) => ({
    drawerPaper: {
        transition: theme.transitions.create("width", {
            duration: theme.transitions.duration.enteringScreen,
            easing: theme.transitions.easing.sharp,
        }),
        whiteSpace: "nowrap",
        width: theme.constant.drawerWidth,
        backgroundImage: "url('http://1-im.guokr.com/88plJVwDfN43JSvvRcPrM33hDJG8f1XLexeCF9Mga6QgAwAAQAYAAEpQ.jpg')",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize: "cover",
        position: "fixed",
        zIndex: theme.zIndex.drawer + 2,
    },
    drawerPaperClose: {
        overflowX: "hidden",
        transition: theme.transitions.create("width", {
            duration: theme.transitions.duration.leavingScreen,
            easing: theme.transitions.easing.sharp,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up("sm")]: {
            width: theme.spacing(9),
        },
    },
    drawer: {
        transition: theme.transitions.create("width", {
            duration: theme.transitions.duration.enteringScreen,
            easing: theme.transitions.easing.sharp,
        }),
        width: theme.constant.drawerWidth,
    },
    mask: {
        backgroundColor: "rgba(0, 0, 0, .7)",
        color: "white",
        height: "1000%",
    },
}))

export const useSideHeaderStyle = makeStyles({
    divider: {
        backgroundColor: "rgba(255,255,255,.3) !important ",
    },
    logo: {
        width: 50,
    },
    userInfo: {
        paddingTop: "20px",
        paddingBottom: "20px",
    },
})

export const useSideListItemStyles = makeStyles(() => ({
    icon: {
        width: 0,
        height: 0,
        display: "inline-block",
        borderTop: "4px solid",
        marginTop: "-3px",
        transition: "all 150ms ease-in",
        borderLeft: "4px solid transparent",
        marginLeft: "88px",
        borderRight: "4px solid transparent",
        verticalAlign: "middle",
    },
    open: {
        transform: "rotate(180deg)",
    },
    sideItem: {
        display: "flex",
        alignItems: "center",
        width: "100%",
        boxSizing: "border-box",
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        paddingLeft: theme.spacing(1),
    },
    active: {
        backgroundColor: "#00acc1",
        borderRadius: theme.shape.borderRadius,
    },
}))
